import React, { useEffect, useRef } from "react";
import { Form, Formik } from "formik";
import FormikControl from "components/wrapperComponents/FormikControl";
import { useState } from "react";
import { CompanyServicesModel } from "model/screensModels/CompanyServicesModel";
import { CompanyServicesSchema } from "schemas/menu/companyServices/CompanyServicesSchema";
import { CompanyServicesService } from "services/menu/companyServicesService/CompanyServicesService";
import { msgTypes } from "constants/msgTypes";
import { UtilService } from 'services/shared/UtilService';

const CreateCompanyServices = ({ setFlag, updateRecord, loadRecentCompanyService}) => {
  const [viewMode, setViewMode] = useState(false);
  // const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [initialValues, setInitialValues] = useState(
    new CompanyServicesModel()
  );
  //const [initialValue, setInitialValue] = useState(new InvoiceManagementModel());
  const fileInputRef = useRef(null);
  const formikRef =  useRef(null);

  useEffect(() => {
   // loadCompany();
    if (updateRecord) {
      setInitialValues(updateRecord)
      //values = updateRecord;
    }
  }, [updateRecord])

  // const loadCompany = async () => {
  //   const res = await UtilService.getCompanyList();
  //   if (res.statusMsg === msgTypes.SUCCESS.msg) {
  //     if(res.data!==''){
  //         setCompanyList(res.data);
  //     }else{
  //         setCompanyList([]);
  //     }
  //   }
  // }


  const onSubmit = async (values: CompanyServicesModel) => {
    addCompanyServices(values);
  };

  useEffect(() => {
    if (updateRecord) {
      setInitialValues(updateRecord);
    }
  }, [updateRecord]);

  //Prepare Data for API
  const prepareRequestBody = async (values: CompanyServicesModel) => {
    const prepareData = new CompanyServicesModel();

    //to assing id based on action
    if (initialValues.serviceId?.length > 0) {
      prepareData.serviceId = initialValues.serviceId;
    } else {
      prepareData.serviceId = values.serviceId
        ? values.serviceId
        : "";
    }
    prepareData.serviceName = values.serviceName ? values.serviceName : "";
    prepareData.status = values.status ? values.status : false;

    return prepareData;
  };

  const addCompanyServices = async (values: CompanyServicesModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await CompanyServicesService.addCompanyServices(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValues(new CompanyServicesModel())
      loadRecentCompanyService();
      formikRef.current.resetForm();
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={CompanyServicesSchema}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {({ isValid, dirty, isSubmitting, values }) => (
          <Form>
            <div className="container">
              <div className="row">

                <div className="col-md-6 position-relative">
                  <FormikControl
                    control="textfield"
                    name="serviceName"
                    label="Service Name"
                    placeholder="Enter Service Name"
                    requiredField
                    disabled={viewMode}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  {!viewMode ? (
                    <div className="mt-3 d-flex justify-content-end">
                      <div className="pr-2">
                        <FormikControl
                          control="button"
                          color="primary"
                          className='btn btn-submit'
                          label={
                            values.serviceId === "" ? "Save" : "Update"
                          }
                          type="submit"
                          disabled={!dirty || !isValid}
                        />
                      </div>&nbsp;&nbsp;
                      <div >
                        <FormikControl
                          control="button"
                          className="btn btn-cancel"
                          color="warning"
                          label="Back"
                          type="reset"
                          onClick={() => {
                            setFlag(false);
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CreateCompanyServices;
